import { FC } from "react";
import { Divider, Stack } from "@mui/material";
import { CommitmentsOverviewMetadataRealCostCard } from "@/components/pages/commtiments/overview/metadata/components/cards/CommitmentsOverviewMetadataRealCostCard";
import { CommitmentsOverviewMetadataPotentialSavingsCard } from "@/components/pages/commtiments/overview/metadata/components/cards/CommitmentsOverviewMetadataPotentialSavingsCard";
import { CommitmentsOverviewMetadataNetSavingsCard } from "@/components/pages/commtiments/overview/metadata/components/cards/CommitmentsOverviewMetadataNetSavingsCard";
import { AwsOverviewEffectiveSavingsRate } from "@/components/pages/commtiments/overview/metadata/components/AwsOverviewEffectiveSavingsRate";

export const CommitmentsOverviewMetadata: FC = () => {
  return (
    <Stack
      gap={1}
      direction="row"
      flexWrap="wrap"
      justifyContent="space-between"
    >
      <Stack
        flex={7}
        border={1}
        spacing={1}
        direction="row"
        bgcolor="white"
        borderRadius={2}
        borderColor="grey.300"
        divider={<Divider orientation="vertical" />}
      >
        <CommitmentsOverviewMetadataRealCostCard />

        <CommitmentsOverviewMetadataPotentialSavingsCard />

        <CommitmentsOverviewMetadataNetSavingsCard />
      </Stack>

      <Stack flex={3}>
        <AwsOverviewEffectiveSavingsRate />
      </Stack>
    </Stack>
  );
};
